// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"24d467cc","719":"de7f3e07"}[chunkId] + ".chunk.js";
};